import gql from 'graphql-tag';

const GET_EXHIBITOR_DETAILS = gql`
    query exhibitors($id: String!) {
        exhibitor(id: $id) {
            id
            booth
            tradeName
            companyName
            street
            number
            complement
            city
            state
            country
            phone
            fax
            site
            email
            mainExecutive
            marketingExecutive
            resume
            areasOfExpertise {
              macro
              expertise
            }
            others
        }
    }
`
;

export default GET_EXHIBITOR_DETAILS;



/** WEBPACK FOOTER **
 ** ./src/graphql/GET_EXHIBITOR_DETAILS.js
 **/